import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";


export const getFeedbackStatus = (workItemId, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/case-feedback/rate/${workItemId}`,
    mountedRef: mountedRef,
    successCallback: successCallback,
    errorCallback: errorCallback
  });    
};

export const postBrokerFeedback = (workItemId, stars, comments, successCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_POST,
    endpoint: `/case-feedback/rate/${workItemId}`,
    payload: {
      stars,
      comments
    },
    mountedRef: mountedRef,
    successCallback: successCallback
  });
};

export const postQA2Feedback = (controlIdNumber, categoryCode, stars, comments, errorCallback) => {
  WebApiRequest({
    method: HTTP_POST,
    endpoint: `/case-feedback/${controlIdNumber}/${categoryCode}`,
    payload: {
      stars,
      comments,
    },
    errorCallback: errorCallback,
});
};

export const postAppraiserFeedback = (controlIdNumber, bulkCaseFeedback, errorCallback) => {
  WebApiRequest({
    method: HTTP_POST,
    endpoint: `/case-feedback/${controlIdNumber}`,
    payload: bulkCaseFeedback,
    errorCallback: errorCallback,
  });
};

export const getAppraiserFeedback = (controlIdNumber, successCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/case-feedback/${controlIdNumber}`,
    successCallback: successCallback,
    mountedRef: mountedRef,
  });
};